module.exports = __webpack_public_path__ + "static/img/2_4_1.5e36bf0e.jpg";